const mediumFreeHeight = '800x0';
const medium = '800x800';
const samllFreeHeight = '200x0';
const small = '200x200';

export { medium, small, samllFreeHeight, mediumFreeHeight };
